import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const ITEMS = [
  "Improve the quality and consistency of hiring decisions",
  "Align hiring managers and TA teams",
  "Increase confidence across stakeholders",
  "Build internal hiring capability over time",
  "Reduce reliance on agencies where unnecessary",
  "Make better use of accessible talent markets",
];

export function Outcomes({ theme }: { theme: Theme }) {
  return (
    <section style={{ padding: "120px 0", borderTop: `1px solid ${theme.border}` }}>
      <SectionHeader theme={theme} kicker="Outcomes" title="What changes with Rarion." />
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 40px",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 16,
        }}
      >
        {ITEMS.map((t) => (
          <div
            key={t}
            style={{
              padding: 24,
              background: theme.surface,
              border: `1px solid ${theme.border}`,
              borderRadius: theme.radius,
              display: "flex",
              gap: 16,
              alignItems: "flex-start",
              minHeight: 120,
            }}
          >
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                background: theme.accent,
                color: theme.onAccent,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                fontFamily: theme.mono,
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              →
            </div>
            <div
              style={{
                fontSize: 16,
                color: theme.fg,
                lineHeight: 1.4,
                fontWeight: 500,
              }}
            >
              {t}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
